import React, { useEffect, useState } from "react";
import axios from "axios";
import "./ProfilePage.css";
import { getUserEmail } from "../../../utils/auth";
import BASE_URL from "../../../config/apiConfig";

const ProfilePage = () => {
  const [user, setUser] = useState({});
  const [subscriptions, setSubscriptions] = useState([]);
  const [newEmail, setNewEmail] = useState("");
  const [secondaryEmails, setSecondaryEmails] = useState([]);
  const [showInput, setShowInput] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const email = getUserEmail();
    if (!email) {
      console.error("User email not found in cookies.");
      return;
    }

    axios
      .post(`${BASE_URL}/api/user/auth/profile`, { email })
      .then((response) => {
        setUser(response.data.user);
        setSubscriptions(response.data.subscriptions);

        let secondaryEmails = response.data.user.secondary_emails;
        if (typeof secondaryEmails === "string") {
          try {
            secondaryEmails = JSON.parse(secondaryEmails);
          } catch (error) {
            console.error("Error fetching profile data:", error);
            secondaryEmails = [];
          }
        }
        setSecondaryEmails(secondaryEmails || []);
      })
      .catch((error) => {
        console.error("Error fetching profile data:", error);
      });
  }, []);

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const addSecondaryEmail = () => {
    if (!validateEmail(newEmail)) {
      setError("Invalid email format.");
      return;
    }
    setError("");

    const user_email = user.email;
    axios
      .post(`${BASE_URL}/api/user/auth/add-secondary-email`, {
        user_email,
        secondary_emails: [newEmail],
      })
      .then((response) => {
        setSecondaryEmails(response.data.secondary_emails);
        setNewEmail("");
        setShowInput(false);
      })
      .catch((error) => {
        console.error("Error adding secondary email:", error);
        setError("Failed to add email.");
      });
  };

  const deleteEmail = (emailToDelete) => {
    axios
      .post(`${BASE_URL}/api/user/auth/delete-secondary-email`, {
        user_email: user.email,
        email_to_delete: emailToDelete,
      })
      .then((response) => {
        setSecondaryEmails(response.data.secondary_emails);
      })
      .catch((error) => {
        console.error("Error deleting secondary email:", error);
        setError("Failed to delete email.");
      });
  };

  return (
    <div className="profile-container">
      {/* Profile Header */}
      <header className="profile-header">
        <div className="profile-header-top">
          <div className="profile-picture">
            <img src="/Images/defaultProfileDp.png" alt="Profile" />
          </div>
          <div className="profile-details">
            <h1>Welcome, {user.name || "User"}</h1>
            <p>
              <strong>Email:</strong> {user.email}
            </p>
            <p>
              <strong>Phone:</strong> {user.phone}
            </p>
            <p>
              <strong>Joined On:</strong>{" "}
              {user.created_at
                ? new Date(user.created_at).toLocaleDateString()
                : "N/A"}
            </p>
          </div>
        </div>
      </header>

      {/* Address Section */}
      <section className="profile-section">
        <h2>Address</h2>
        <p>
          {subscriptions.length > 0
            ? subscriptions[0].address
            : "No address available."}
        </p>
      </section>

      {/* Secondary Emails Section */}
      <section className="profile-section">
        <h2>Secondary Emails</h2>
        <button
          className="add-email-btn"
          onClick={() => setShowInput(!showInput)}
        >
          {showInput ? "Cancel" : "Add Email"}
        </button>

        {showInput && (
          <div className="email-input-container">
            <input
              type="email"
              placeholder="Enter secondary email"
              value={newEmail}
              onChange={(e) => setNewEmail(e.target.value)}
              className="email-input"
            />
            <button onClick={addSecondaryEmail} className="submit-email-btn">
              Add
            </button>
            {error && <p className="error-text">{error}</p>}
          </div>
        )}

        {/* Display Secondary Emails */}
        {secondaryEmails.length > 0 ? (
          <div className="profile-table-container">
            <table className="profile-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Email</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {secondaryEmails.map((email, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{email}</td>
                    <td>
                      <button
                        onClick={() => deleteEmail(email)}
                        className="delete-btn"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p>No secondary emails added yet.</p>
        )}
      </section>
    </div>
  );
};

export default ProfilePage;
